/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Source_TextInputs */



/**
* | output |
* | --- |
* | "Source text" |
*
* @param {Event_Group_Sync_Property_Source_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_source_text = /** @type {((inputs?: Event_Group_Sync_Property_Source_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Source_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "de") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "es") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Source text")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Source text")
	return /** @type {LocalizedString} */ ("Source text")
});